import React from 'react'
import PropTypes from 'prop-types'
import Translations from '../../../../../requests/apa/Translator';
import Assets from '../../../../../requests/apa/Asset';
import './_MatchDetailHeader.scss'
import Utils from '../../../../../utils/Utils';
import logger from 'src/utils/logger/logger';

const MONTH_EN_TO_ES = {
  JANUARY: 'ENERO', FEBRUARY: 'FEBRERO', MARCH: 'MARZO',
  APRIL: 'ABRIL', MAY: 'MAYO', JUNE: 'JUNIO',
  JULY: 'JULIO', AUGUST: 'AGOSTO', SEPTEMBER: 'SEPTIEMBRE',
  OCTOBER: 'OCTUBRE', NOVEMBER: 'NOVIEMBRE', DECEMBER: 'DICIEMBRE'
}

function localizeDate(dateStr) {
  if (!dateStr) return dateStr
  return dateStr.replace(
    /(?:DE\s+)?\b(JANUARY|FEBRUARY|MARCH|APRIL|MAY|JUNE|JULY|AUGUST|SEPTEMBER|OCTOBER|NOVEMBER|DECEMBER)\b/gi,
    function (_, month) {
      return 'DE ' + (MONTH_EN_TO_ES[month.toUpperCase()] || month.toUpperCase())
    }
  )
}

const HeaderBadge = ({ team, isAway, showBadge }) => {
  const hasName = team.name !== undefined && team.name !== ''
  return (
    <div className={`match-detail-header__badge${isAway ? ' match-detail-header__badge--away' : ''}${!hasName ? ' match-detail-header__badge--empty' : ''}`}>
      {hasName ? (
        team.badgeUrl || team.flagUrl ? (
          <img src={team.badgeUrl || team.flagUrl} alt={team.name} className='match-detail-header__flag' />
        ) : (
          <img src={Assets.get('login_title_icon_logoClarovideo')} alt={team.name} className='match-detail-header__badge-text'></img>
        )
      ) : null}
    </div>
  )
}

const GoalList = ({ teamName, goals, extraGoals, alignRight }) => (
  <div className={`match-detail-header__goals${alignRight ? ' match-detail-header__goals--right' : ''}`}>
    <div className={`match-detail-header__goal-item match-detail-header__goal-item--team match-detail-header__goal-item${alignRight ? '--away' : '--home'}`}>
      <span className={`match-detail-header__team-name${alignRight ? ' match-detail-header__team-name--away' : ' match-detail-header__team-name--home'}`}>{Utils.cutPlayerString(teamName, 15)}</span>
    </div>
    {goals.slice(0, 3).map((goal, index) => (
      <div key={`${goal.player}-${index}`} className={`match-detail-header__goal-item match-detail-header__goal-item${alignRight ? '--away' : '--home'}`}>
        <span className='match-detail-header__goal-player'>{goal.player}</span>
        <span className='match-detail-header__goal-minute'>{goal.minute}</span>
      </div>
    ))}
    {goals.length > 3 && (
      <div className={`match-detail-header__goal-item match-detail-header__goal-item--extra match-detail-header__goal-item${alignRight ? '--away' : '--home'}`}>
        +{goals.length - 3} gol{goals.length - 3 > 1 ? 'es' : ''} más
      </div>
    )}
  </div>
)

const GoalListScheduled = ({ teamName, alignRight }) => (
  <div className={`match-detail-header__goals${alignRight ? ' match-detail-header__goals--right' : ''}`}>
    <div className={`match-detail-header__goal-item match-detail-header__goal-item--team match-detail-header__goal-item${alignRight ? '--away' : '--home'}`}>
      <span className={`match-detail-header__team-name${alignRight ? ' match-detail-header__team-name--away' : ' match-detail-header__team-name--home'}`}>{Utils.cutPlayerString(teamName, 15)}</span>
    </div>
  </div>
)

const MatchDetailHeader = ({ matchData, teamColors, isSingleChannel, hasPlaybackError, isPlayBackConfigEnable }) => {
  logger.debug(':::MDH status:', matchData && matchData.status, '| isPlayBackConfigEnable:', isPlayBackConfigEnable, '| scores:', matchData && matchData.homeScore, '-', matchData && matchData.awayScore);
  //const isLiveNoPlay = true;//!!isLive && !((matchData || {}).canPlay)
  const isFinished = true //!!((matchData || {}).isFinished)

  //Para mostrar el layout de EN VIVO se deben cumplir las siguientes condiciones:
  //1. El partido debe estar en vivo (isLive = true)
  //2. El partido no debe estar finalizado (isFinished = false)
  //3. La operación debe tener permiso de reproducción (havePermisoLaOperacion = true)
  //4.-showLiveLayout = true


  const havePermisoLaOperacion = true; // Esta si es necesaria cuando el usuario no tenga permisos de reproducción para que solo se vea la cabecera


  const {
    homeTeam = {},
    awayTeam = {},
    homeScore = 0,
    awayScore = 0,
    status,
    competition,
    group,
    date,
    time,
    city,
    referee,
    venue,
    attendance,
    homeGoals = [],
    awayGoals = [],
    homeOtherGoals = 3,
    awayOtherGoals = 0,
    stage,
  } = matchData || {}

  const showLiveLayout = status;

  const safeDate = localizeDate(date)

  const safeTeamColors = {
    home: (teamColors && teamColors.home) || '#7cbadf',
    away: (teamColors && teamColors.away) || '#d10a0a'
  }

  const getTagLiveEvent = () => {
    const label = Translations.get('tag_envivo');

    if(label !== 'tag_envivo') return label;

    return Translations.get('Tag_EnVivo');
  }

  const isFinishedWithPip = (showLiveLayout === 'FINISHED' || showLiveLayout === 'COMPLETED') && isPlayBackConfigEnable;

  if(havePermisoLaOperacion && (showLiveLayout === 'IN_PROGRESS' || showLiveLayout === 'SCHEDULED' || isFinishedWithPip) && isPlayBackConfigEnable){
    return (
       <section
      className={
        'match-detail-header'
         + ' match-detail-header--live'
      }
      style={Object.assign(
        { '--match-header-home-color': safeTeamColors.home, '--match-header-away-color': safeTeamColors.away },
        isSingleChannel ? { height: '29.733rem' } : {},
        hasPlaybackError ? { height: '29.4rem' } : {}
      )}
    >
      {(showLiveLayout === 'IN_PROGRESS' || showLiveLayout === 'SCHEDULED' || isFinishedWithPip) ? (
        <div className='match-detail-header__live-wrap'>
          {showLiveLayout === 'IN_PROGRESS' && (<span className='match-detail-header__live-tag'>{Utils.cutPlayerString(getTagLiveEvent(), 7)}</span>)}
          {isFinishedWithPip && (<span className={(showLiveLayout === 'COMPLETED' || showLiveLayout === 'FINISHED') ? 'match-detail-header__live-tag--completed' : 'match-detail-header__live-tag'}>{Translations.get('eventodeportivo_carruseletapas_ficha_texto_COMPLETED')}</span>)}

          <div className='match-detail-header__live-badge match-detail-header__live-badge--home'>
            {homeTeam.badgeUrl
              ? <img src={homeTeam.badgeUrl} alt={homeTeam.name} className='match-detail-header__live-badge-img' />
              : <span className='match-detail-header__live-badge-initials'>{homeTeam.shortName}</span>
            }
          </div>
          {homeTeam.flagUrl ? (
            <img src={homeTeam.flagUrl} alt={homeTeam.name} className='match-detail-header__live-flag match-detail-header__live-flag--home' />
          ) : null}

          {(showLiveLayout === 'IN_PROGRESS' || isFinishedWithPip) && (<div className='match-detail-header__live-score'>
            <span className='match-detail-header__live-score-num'>{homeScore || 0}</span>
            <span className='match-detail-header__live-score-sep'>-</span>
            <span className='match-detail-header__live-score-num'>{awayScore || 0}</span>
          </div>
          )}

          {showLiveLayout === 'SCHEDULED' && (<div className='match-detail-header__live-score'>
            <span className='match-detail-header__live-score-sep'>VS</span>
          </div>
          )}

          <div className='match-detail-header__live-badge match-detail-header__live-badge--away'>
            {awayTeam.badgeUrl
              ? <img src={awayTeam.badgeUrl} alt={awayTeam.name} className='match-detail-header__live-badge-img' />
              : <span className='match-detail-header__live-badge-initials'>{awayTeam.shortName}</span>
            }
          </div>
          {awayTeam.flagUrl ? (
            <img src={awayTeam.flagUrl} alt={awayTeam.name} className='match-detail-header__live-flag match-detail-header__live-flag--away' />
          ) : null}

          <p className='match-detail-header__live-name match-detail-header__live-name--home'>{homeTeam.name}</p>
          <p className='match-detail-header__live-name match-detail-header__live-name--away'>{awayTeam.name}</p>

          <div className='match-detail-header__live-goals match-detail-header__live-goals--home'>
            {homeGoals.slice(0, 3).map(function (goal, i) {
              return (
                <div key={goal.player + '-' + i} className='match-detail-header__live-goal-row'>
                  <span className='match-detail-header__live-goal-player'>{goal.player}</span>
                  <span className='match-detail-header__live-goal-minute'>{goal.minute}</span>
                </div>
              )
            })}
            {homeGoals.length > 3 && (
              <div className='match-detail-header__live-goal-row match-detail-header__live-goal-row--extra'>
                +{homeGoals.length - 3} gol{homeGoals.length - 3 > 1 ? 'es' : ''} más
              </div>
            )}
          </div>

          <div className='match-detail-header__live-goals match-detail-header__live-goals--away'>
            {awayGoals.slice(0, 3).map(function (goal, i) {
              return (
                <div key={goal.player + '-' + i} className='match-detail-header__live-goal-row'>
                  <span className='match-detail-header__live-goal-player'>{goal.player}</span>
                  <span className='match-detail-header__live-goal-minute'>{goal.minute}</span>
                </div>
              )
            })}
            {awayGoals.length > 3 && (
              <div className='match-detail-header__live-goal-row match-detail-header__live-goal-row--extra'>
                +{awayGoals.length - 3} gol{awayGoals.length - 3 > 1 ? 'es' : ''} más
              </div>
            )}
          </div>

          {/* First row */}
          <p className='match-detail-header__live-meta match-detail-header__live-meta--phase'>
            {/* Phase */}
            <span>{Translations.get(`eventodeportivo_texto_etapa_${stage}`)}</span>
            { group && <span> - </span> }
            { group && <span>{group}</span> }
            <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>

            {/* Date & Time */}
            <span>{safeDate}</span>
            <span> - </span>
            <span>{time}</span>
            <span className='match-detail-header__meta-sep'>/</span>

            {/* City */}
            <span>{city}</span>
            <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>

            {/* Referee */}
            <span>Árbitro: </span>
            <span>{referee}</span>
          </p>

          {/* Second row */}
          <p className='match-detail-header__live-meta match-detail-header__live-meta--venue'>
            <span>{venue}</span>
            <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
            <span>Asistencia: </span>
            <span>{attendance}</span>
          </p>
        </div>
      ) : showLiveLayout === 'FINISHED' || showLiveLayout === 'COMPLETED' ? (
        <div className='match-detail-header__non-live-finished'>
          <div className='match-detail-header__content'>
            <div className='match-detail-header__panel match-detail-header__panel--home'>
              <HeaderBadge team={homeTeam} />
              <div className='match-detail-header__team-row'>
                {homeTeam.flagUrl ? (
                  <img src={homeTeam.flagUrl} alt={homeTeam.name} className='match-detail-header__flag-small' />
                ) : null}
              </div>
              <span className='match-detail-header__team-divider' aria-hidden='true' />
              <GoalList teamName={homeTeam.name} goals={homeGoals} extraGoals={homeOtherGoals} />
            </div>

            <div className='match-detail-header__score-center'>
              <div className='match-detail-header__status'>{Translations.get(`eventodeportivo_texto_finalizado_${status}`)}</div>
              {(homeScore !== undefined && homeScore !== null) ? (
                <div>
                  <div className='match-detail-header__score-number'>{homeScore || 0}</div>
                  <div className='match-detail-header__score-divider'>-</div>
                  <div className='match-detail-header__score-number'>{awayScore}</div>
                </div>
              ) : (
                <div className='match-detail-header__vs'>vs</div>
              )}
            </div>

            <div className='match-detail-header__panel match-detail-header__panel--away'>
              <GoalList teamName={awayTeam.name} goals={awayGoals} extraGoals={awayOtherGoals} alignRight />
              <span className='match-detail-header__team-divider--away' aria-hidden='true' />
              <div className='match-detail-header__team-row match-detail-header__team-row--away'>
                {awayTeam.flagUrl ? (
                  <img src={awayTeam.flagUrl} alt={awayTeam.name} className='match-detail-header__flag-small' />
                ) : <img src={Assets.get('eventodeportivo_placeholder_imagen_escudo_2')} className='match-detail-header__flag-small' />}
              </div>
              <HeaderBadge team={awayTeam} isAway />
            </div>
          </div>

          <div className='match-detail-header__footer'>
            <div className='match-detail-header__meta'>
              <span className='match-detail-header__meta-item'>{Translations.get(`eventodeportivo_texto_etapa_${stage}`)}</span>
              { group && <span className='match-detail-header__meta-item'> - </span> }
              <span className='match-detail-header__meta-item match-detail-header__meta-item--stacked'>
                { group && <span className='match-detail-header__meta-value'>{group}</span> }
                <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
                <span className='match-detail-header__meta-item'>{safeDate}</span>
              </span>

              <span className='match-detail-header__meta-item'>-</span>
              <span className='match-detail-header__meta-item'>{time}</span>
              <span className='match-detail-header__meta-sep'>/</span>
              <span className='match-detail-header__meta-item'>{city}</span>
              <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
              <span className='match-detail-header__meta-item match-detail-header__meta-item--stacked'>
                <span className='match-detail-header__meta-label'>Árbitro: </span>
                <span className='match-detail-header__meta-value'>{referee}</span>
              </span>
              <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
              <span className='match-detail-header__meta-item match-detail-header__meta-item--stacked'>
                <span className='match-detail-header__meta-value'>{venue}</span>
              </span>
              <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
              <span className='match-detail-header__meta-item'>Asistencia: {attendance}</span>
            </div>
          </div>
        </div>
      ) : showLiveLayout === 'SCHEDULED' ? (
        <div className='match-detail-header__non-live'>
          <div className='match-detail-header__content'>
            <div className='match-detail-header__panel match-detail-header__panel--home'>
              <HeaderBadge team={homeTeam} />
              <div className='match-detail-header__team-row'>
                {homeTeam.flagUrl ? (
                  <img src={homeTeam.flagUrl} alt={homeTeam.name} className='match-detail-header__flag-small' />
                ) : <img src={Assets.get('eventodeportivo_placeholder_imagen_escudo_2')} className='match-detail-header__flag-small' />}
              </div>
              <span className='match-detail-header__team-divider' aria-hidden='true' />
              <GoalListScheduled teamName={(homeTeam.name !== undefined && homeTeam.name !== '') ? homeTeam.name : Translations.get('eventodeportivo_pais_texto_pordefinir')} />
            </div>

            <div className='match-detail-header__score-center'>
              <div className='match-detail-header__vs'>{Translations.get(`eventodeportivo_texto_vs_${showLiveLayout}`)}</div>
            </div>

            <div className='match-detail-header__panel match-detail-header__panel--away'>
              <GoalListScheduled teamName={(awayTeam.name !== undefined && awayTeam.name !== '') ? awayTeam.name : Translations.get('eventodeportivo_pais_texto_pordefinir')} alignRight />
              <span className='match-detail-header__team-divider--away' aria-hidden='true' />
              <div className='match-detail-header__team-row match-detail-header__team-row--away'>
                {awayTeam.flagUrl ? (
                  <img src={awayTeam.flagUrl} alt={awayTeam.name} className='match-detail-header__flag-small' />
                ) : <img src={Assets.get('eventodeportivo_placeholder_imagen_escudo_2')} className='match-detail-header__flag-small' />}
              </div>
              <HeaderBadge team={awayTeam} isAway  showBadge = {(awayTeam.name !== undefined && awayTeam.name !== '') ? true : false}/>
            </div>
          </div>

          <div className='match-detail-header__footer'>
            <div className='match-detail-header__meta'>
              <span className='match-detail-header__meta-item'>{Translations.get(`eventodeportivo_texto_etapa_${stage}`)}</span>
              { group &&  <span className='match-detail-header__meta-item'> - </span> }
              <span className='match-detail-header__meta-item match-detail-header__meta-item--stacked'>
                { group && <span className='match-detail-header__meta-value'>{group}</span> }
                <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
                <span className='match-detail-header__meta-item'>{safeDate}</span>
              </span>

              <span className='match-detail-header__meta-item'>-</span>
              <span className='match-detail-header__meta-item'>{time}</span>
              <span className='match-detail-header__meta-sep'>/</span>
              <span className='match-detail-header__meta-item'>{city}</span>
              <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
              <span className='match-detail-header__meta-item match-detail-header__meta-item--stacked'>
                <span className='match-detail-header__meta-label'>Árbitro: </span>
                <span className='match-detail-header__meta-value__no__disponible'>Aún no disponible</span>
              </span>
              <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
              <span className='match-detail-header__meta-item match-detail-header__meta-item--stacked'>
                <span className='match-detail-header__meta-value'>{venue}</span>
              </span>
              <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
              <span className='match-detail-header__meta-item'>Asistencia:</span>
              <span className='match-detail-header__meta-value__no__disponible'>Aún no disponible</span>
            </div>
          </div>
        </div>
      ) : null}
      </section>
    )
  }



  return (
    <section
      className={
        'match-detail-header'
         + (havePermisoLaOperacion && showLiveLayout === 'IN_PROGRESS' ? ' match-detail-header--live' : '')//Debe de entrar aquí cuando la operación tenga permiso de reproducción
         + (status === 'SCHEDULED' ? ' match-detail-header--live-no-play' : '') //Si el partido está programado, se muestra el layout de EN VIVO pero sin opción de reproducción
      }
      style={Object.assign(
        { '--match-header-home-color': safeTeamColors.home, '--match-header-away-color': safeTeamColors.away },
        isSingleChannel ? { height: '29.733rem' } : {},
        hasPlaybackError ? { height: '29.4rem' } : {}
      )}
    >
      {showLiveLayout === 'IN_PROGRESS' ? (
        <div className='match-detail-header__live-wrap'>
          <span className='match-detail-header__live-tag'>{Utils.cutPlayerString(getTagLiveEvent(), 7)}</span>

          <div className='match-detail-header__live-badge match-detail-header__live-badge--home'>
            {homeTeam.badgeUrl
              ? <img src={homeTeam.badgeUrl} alt={homeTeam.name} className='match-detail-header__live-badge-img' />
              : <span className='match-detail-header__live-badge-initials'>{homeTeam.shortName}</span>
            }
          </div>
          {homeTeam.flagUrl ? (
            <img src={homeTeam.flagUrl} alt={homeTeam.name} className='match-detail-header__live-flag match-detail-header__live-flag--home' />
          ) : null}

          <div className='match-detail-header__live-score'>
            <span className='match-detail-header__live-score-num'>{homeScore || 0}</span>
            <span className='match-detail-header__live-score-sep'>-</span>
            <span className='match-detail-header__live-score-num'>{awayScore || 0}</span>
          </div>

          <div className='match-detail-header__live-badge match-detail-header__live-badge--away'>
            {awayTeam.badgeUrl
              ? <img src={awayTeam.badgeUrl} alt={awayTeam.name} className='match-detail-header__live-badge-img' />
              : <span className='match-detail-header__live-badge-initials'>{awayTeam.shortName}</span>
            }
          </div>
          {awayTeam.flagUrl ? (
            <img src={awayTeam.flagUrl} alt={awayTeam.name} className='match-detail-header__live-flag match-detail-header__live-flag--away' />
          ) : null}

          <p className='match-detail-header__live-name match-detail-header__live-name--home'>{homeTeam.name}</p>
          <p className='match-detail-header__live-name match-detail-header__live-name--away'>{awayTeam.name}</p>

          <div className='match-detail-header__live-goals match-detail-header__live-goals--home'>
            {homeGoals.slice(0, 3).map(function (goal, i) {
              return (
                <div key={goal.player + '-' + i} className='match-detail-header__live-goal-row'>
                  <span className='match-detail-header__live-goal-player'>{goal.player}</span>
                  <span className='match-detail-header__live-goal-minute'>{goal.minute}</span>
                </div>
              )
            })}
            {homeGoals.length > 3 && (
              <div className='match-detail-header__live-goal-row match-detail-header__live-goal-row--extra'>
                +{homeGoals.length - 3} gol{homeGoals.length - 3 > 1 ? 'es' : ''} más
              </div>
            )}
          </div>

          <div className='match-detail-header__live-goals match-detail-header__live-goals--away'>
            {awayGoals.slice(0, 3).map(function (goal, i) {
              return (
                <div key={goal.player + '-' + i} className='match-detail-header__live-goal-row'>
                  <span className='match-detail-header__live-goal-player'>{goal.player}</span>
                  <span className='match-detail-header__live-goal-minute'>{goal.minute}</span>
                </div>
              )
            })}
            {awayGoals.length > 3 && (
              <div className='match-detail-header__live-goal-row match-detail-header__live-goal-row--extra'>
                +{awayGoals.length - 3} gol{awayGoals.length - 3 > 1 ? 'es' : ''} más
              </div>
            )}
          </div>

          {/* First row */}
          <p className='match-detail-header__live-meta match-detail-header__live-meta--phase'>
            {/* Phase */}
            <span>{Translations.get(`eventodeportivo_texto_etapa_${stage}`)}</span>
            { group && <span> - </span> }
            { group && <span>{group}</span> }
            <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>

            {/* Date & Time */}
            <span>{safeDate}</span>
            <span> - </span>
            <span>{time}</span>
            <span className='match-detail-header__meta-sep'>/</span>

            {/* City */}
            <span>{city}</span>
            <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>

            {/* Referee */}
            <span>Árbitro: </span>
            <span>{referee}</span>
          </p>

          {/* Second row */}
          <p className='match-detail-header__live-meta match-detail-header__live-meta--venue'>
            <span>{venue}</span>
            <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
            <span>Asistencia: </span>
            <span>{attendance}</span>
          </p>
        </div>
      ) : showLiveLayout === 'FINISHED' || showLiveLayout === 'COMPLETED' ? (
        <div className='match-detail-header__non-live-finished'>
          <div className='match-detail-header__content'>
            <div className='match-detail-header__panel match-detail-header__panel--home'>
              <HeaderBadge team={homeTeam} />
              <div className='match-detail-header__team-row'>
                {homeTeam.flagUrl ? (
                  <img src={homeTeam.flagUrl} alt={homeTeam.name} className='match-detail-header__flag-small' />
                ) : null}
              </div>
              <span className='match-detail-header__team-divider' aria-hidden='true' />
              <GoalList teamName={homeTeam.name} goals={homeGoals} extraGoals={homeOtherGoals} />
            </div>

            <div className='match-detail-header__score-center'>
              <div className='match-detail-header__status'>{Translations.get(`eventodeportivo_texto_finalizado_${status}`)}</div>
              {(homeScore !== undefined && homeScore !== null) ? (
                <div>
                  <div className='match-detail-header__score-number'>{homeScore || 0}</div>
                  <div className='match-detail-header__score-divider'>-</div>
                  <div className='match-detail-header__score-number'>{awayScore || 0}</div>
                </div>
              ) : (
                <div className='match-detail-header__vs'>vs</div>
              )}
            </div>

            <div className='match-detail-header__panel match-detail-header__panel--away'>
              <GoalList teamName={awayTeam.name} goals={awayGoals} extraGoals={awayOtherGoals} alignRight />
              <span className='match-detail-header__team-divider--away' aria-hidden='true' />
              <div className='match-detail-header__team-row match-detail-header__team-row--away'>
                {awayTeam.flagUrl ? (
                  <img src={awayTeam.flagUrl} alt={awayTeam.name} className='match-detail-header__flag-small' />
                ) : <img src={Assets.get('eventodeportivo_placeholder_imagen_escudo_2')} className='match-detail-header__flag-small' />}
              </div>
              <HeaderBadge team={awayTeam} isAway />
            </div>
          </div>

          <div className='match-detail-header__footer'>
            <div className='match-detail-header__meta'>
              <span className='match-detail-header__meta-item'>{Translations.get(`eventodeportivo_texto_etapa_${stage}`)}</span>
              { group && <span className='match-detail-header__meta-item'> - </span> }
              <span className='match-detail-header__meta-item match-detail-header__meta-item--stacked'>
                { group && <span className='match-detail-header__meta-value'>{group}</span> }
                <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
                <span className='match-detail-header__meta-item'>{safeDate}</span>
              </span>

              <span className='match-detail-header__meta-item'>-</span>
              <span className='match-detail-header__meta-item'>{time}</span>
              <span className='match-detail-header__meta-sep'>/</span>
              <span className='match-detail-header__meta-item'>{city}</span>
              <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
              <span className='match-detail-header__meta-item match-detail-header__meta-item--stacked'>
                <span className='match-detail-header__meta-label'>Árbitro: </span>
                <span className='match-detail-header__meta-value'>{referee}</span>
              </span>
              <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
              <span className='match-detail-header__meta-item match-detail-header__meta-item--stacked'>
                <span className='match-detail-header__meta-value'>{venue}</span>
              </span>
              <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
              <span className='match-detail-header__meta-item'>Asistencia: {attendance}</span>
            </div>
          </div>
        </div>
      ) : showLiveLayout === 'SCHEDULED' ? (
        <div className='match-detail-header__non-live'>
          <div className='match-detail-header__content'>
            <div className='match-detail-header__panel match-detail-header__panel--home'>
              <HeaderBadge team={homeTeam} />
              <div className='match-detail-header__team-row'>
                {homeTeam.flagUrl ? (
                  <img src={homeTeam.flagUrl} alt={homeTeam.name} className='match-detail-header__flag-small' />
                ) : <img src={Assets.get('eventodeportivo_placeholder_imagen_escudo_2')} className='match-detail-header__flag-small' />}
              </div>
              <span className='match-detail-header__team-divider' aria-hidden='true' />
              <GoalListScheduled teamName={(homeTeam.name !== undefined && homeTeam.name !== '') ? homeTeam.name : Translations.get('eventodeportivo_pais_texto_pordefinir')} />
            </div>

            <div className='match-detail-header__score-center'>
              <div className='match-detail-header__vs'>{Translations.get(`eventodeportivo_texto_vs_${showLiveLayout}`)}</div>
            </div>

            <div className='match-detail-header__panel match-detail-header__panel--away'>
              <GoalListScheduled teamName={(awayTeam.name !== undefined && awayTeam.name !== '') ? awayTeam.name : Translations.get('eventodeportivo_pais_texto_pordefinir')} alignRight />
              <span className='match-detail-header__team-divider--away' aria-hidden='true' />
              <div className='match-detail-header__team-row match-detail-header__team-row--away'>
                {awayTeam.flagUrl ? (
                  <img src={awayTeam.flagUrl} alt={awayTeam.name} className='match-detail-header__flag-small' />
                ) : <img src={Assets.get('eventodeportivo_placeholder_imagen_escudo_2')} className='match-detail-header__flag-small' />}
              </div>
              <HeaderBadge team={awayTeam} isAway  showBadge = {(awayTeam.name !== undefined && awayTeam.name !== '') ? true : false}/>
            </div>
          </div>

          <div className='match-detail-header__footer'>
            <div className='match-detail-header__meta'>
              <span className='match-detail-header__meta-item'>{Translations.get(`eventodeportivo_texto_etapa_${stage}`)}</span>
              { group &&  <span className='match-detail-header__meta-item'> - </span> }
              <span className='match-detail-header__meta-item match-detail-header__meta-item--stacked'>
                { group && <span className='match-detail-header__meta-value'>{group}</span> }
                <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
                <span className='match-detail-header__meta-item'>{safeDate}</span>
              </span>

              <span className='match-detail-header__meta-item'>-</span>
              <span className='match-detail-header__meta-item'>{time}</span>
              <span className='match-detail-header__meta-sep'>/</span>
              <span className='match-detail-header__meta-item'>{city}</span>
              <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
              <span className='match-detail-header__meta-item match-detail-header__meta-item--stacked'>
                <span className='match-detail-header__meta-label'>Árbitro: </span>
                <span className='match-detail-header__meta-value__no__disponible'>Aún no disponible</span>
              </span>
              <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
              <span className='match-detail-header__meta-item match-detail-header__meta-item--stacked'>
                <span className='match-detail-header__meta-value'>{venue}</span>
              </span>
              <span className='match-detail-header__meta-sep'>{Translations.get(`eventodeportivo_texto_separador`)}</span>
              <span className='match-detail-header__meta-item'>Asistencia:</span>
              <span className='match-detail-header__meta-value__no__disponible'>Aún no disponible</span>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  )
}

MatchDetailHeader.propTypes = {
  matchData: PropTypes.shape({
    competition: PropTypes.string,
    group: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    status: PropTypes.string,
    venue: PropTypes.string,
    city: PropTypes.string,
    referee: PropTypes.string,
    attendance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    homeScore: PropTypes.number,
    awayScore: PropTypes.number,
    homeTeam: PropTypes.shape({
      name: PropTypes.string,
      shortName: PropTypes.string,
      flagUrl: PropTypes.string,
      badgeUrl: PropTypes.string
    }),
    awayTeam: PropTypes.shape({
      name: PropTypes.string,
      shortName: PropTypes.string,
      flagUrl: PropTypes.string,
      badgeUrl: PropTypes.string
    }),
    homeGoals: PropTypes.arrayOf(
      PropTypes.shape({ player: PropTypes.string, minute: PropTypes.string })
    ),
    awayGoals: PropTypes.arrayOf(
      PropTypes.shape({ player: PropTypes.string, minute: PropTypes.string })
    ),
    homeEvents: PropTypes.array,
    awayEvents: PropTypes.array,
    homeOtherGoals: PropTypes.number,
    awayOtherGoals: PropTypes.number
  }),
  teamColors: PropTypes.shape({
    home: PropTypes.string,
    away: PropTypes.string
  }),
  isSingleChannel: PropTypes.bool,
  hasPlaybackError: PropTypes.bool
}

MatchDetailHeader.defaultProps = {
  matchData: {},
  teamColors: {
    home: '#7cbadf',
    away: '#d10a0a'
  },
  isSingleChannel: false,
  hasPlaybackError: false
}

export default MatchDetailHeader



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailHeader/MatchDetailHeader.jsx